// extracted by mini-css-extract-plugin
export default {"multiline-text":"duplicate-rows__multiline-text--GlYl9","multilineText":"duplicate-rows__multiline-text--GlYl9"};